import { takeEvery } from 'redux-saga/effects'
import { CHANNEL_DATA } from 'CHANNEL_DATA'

const makeLayoutUsersChannelData = (layoutId, onChannelData) => {
  return function * layoutUsersChannelData (action) {
    const { channel, actionName, elementName, data } = action.payload

    if (channel === `homeLayout-${layoutId}`) {
      yield onChannelData({ channel, actionName, elementName, data })
    }
  }
}

export default function * layoutUsersChannelData (layoutId, onChannelData) {
  const channelData = makeLayoutUsersChannelData(layoutId, onChannelData)

  yield takeEvery(CHANNEL_DATA, channelData)
}
